import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

import routerChannels from "@/router/channels";
import routerSegments from "@/router/segments";
import routerPartners from "@/router/partners";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * disabled: true                 if set true, item will disabled link in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    activeMenuParent: true     if set true, the parent item will highlight
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  // {
  //   path: "/login",
  //   name: "login",
  //   component: () => import("@/views/Login.vue"),
  //   hidden: true,
  // },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: { title: "Главная", icon: "dashboard" },
      },
    ],
  },
  {
    path: "/channels",
    component: Layout,
    meta: { title: "Каналы", icon: "el-one" },
    redirect: "/channels/list",
    children: routerChannels("/channels"),
  },
  {
    path: "/segments",
    component: Layout,
    meta: { title: "Сегменты", icon: "el-two" },
    redirect: "/segments/list",
    children: routerSegments("/segments"),
  },
  {
    path: "/partners",
    component: Layout,
    meta: { title: "Партнеры", icon: "el-three" },
    redirect: "/partners/list",
    children: routerPartners("/partners"),
  },
  { path: "*", redirect: "/404", hidden: true },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
